/* eslint-disable import/no-anonymous-default-export */
export default [
    {
        navigate: '/',
        title_en: 'Home',
        title_cn: '主页',
    },
    {
        navigate: '/about-us',
        title_en: 'About Us',
        title_cn: '关于我们',
    },
    {
        navigate: '/activity',
        title_en: 'Activity',
        title_cn: '活动',
    },
    {
        navigate: '/performance-hire',
        title_en: 'Performance Hire',
        title_cn: '演出',
    },
    {
        navigate: '/lesson',
        title_en: 'Lesson',
        title_cn: '课程',
    },
    {
        navigate: '/contact',
        title_en: 'Contact',
        title_cn: '联系我们',
    },
]